const SCENE_HEADER_REGEX = /^###\s+Sc[eè]ne\s+(?:n°|no\.?|#)?\s*\d+:\s*(.*)/;

interface ParsedScene {
  title: string;
  media: string;
  interactions: string[];
}

const parseMarkdown = (markdown: string) => {
  const lines = markdown.split("\n");
  const scenes: ParsedScene[] = [];

  let currentScene: ParsedScene | null = null;

  for (const line of lines) {
    const sceneMatch = line.match(SCENE_HEADER_REGEX);
    if (sceneMatch) {
      if (currentScene) {
        scenes.push(currentScene);
      }
      currentScene = { title: sceneMatch[1].trim(), media: "", interactions: [] };
      continue;
    }

    if (!currentScene) continue;

    if (line.startsWith("#### Média:") || line.startsWith("#### Media:")) {
      currentScene.media = line.replace(/^#### M[ée]dia:\s?/, "");
    } else if (line.startsWith("- ")) {
      // Check if interaction is in bold or not
      const boldMatch = line.match(/\*\*(.*?)\*\*/);
      const regularMatch = line.match(/- (.*?):/);

      if (boldMatch) {
        currentScene.interactions.push(boldMatch[1].trim());
      } else if (regularMatch) {
        currentScene.interactions.push(regularMatch[1].trim());
      }
    }
  }

  if (currentScene) {
    scenes.push(currentScene);
  }

  return scenes;
};

export default parseMarkdown;
